"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FCard = void 0;
const react_1 = __importStar(require("react"));
const card_futuristic_primary_png_1 = __importDefault(require("../assets/images/card-futuristic-primary.png"));
const card_futuristic_tartiary_svg_1 = __importDefault(require("../assets/images/card-futuristic-tartiary.svg"));
const card_futuristic_quadratic_svg_1 = __importDefault(require("../assets/images/card-futuristic-quadratic.svg"));
const FCard = ({ variant = "primary", className = "", children = undefined, style = undefined, width, height }) => {
    const card = (0, react_1.useRef)("");
    const [cardSize, setCardSize] = (0, react_1.useState)(0);
    (0, react_1.useLayoutEffect)(() => {
        function handleResize() {
            setCardSize(card.current.offsetWidth);
            // setWindowDimensions(getWindowDimensions());
            console.log("width", card.current.offsetWidth);
        }
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);
    return (react_1.default.createElement("div", { ref: card, className: `f-card f-card-${variant} ${variant.includes("futuristic") ? "f-card-futuristic" : ""} ${className} ${variant.includes("futuristic-secondary") ? (cardSize > 722 ? "bg-contain" : "bg-cover") : ""}`, style: height || width ? Object.assign(Object.assign({}, style), { height: `${height}`, maxWidth: `${width}` }) : undefined },
        react_1.default.createElement("div", { className: "f-card-body" }, children),
        variant.includes("futuristic") && variant === "futuristic-primary" ? (react_1.default.createElement("div", { className: `bg-futuristic` },
            react_1.default.createElement("img", { src: card_futuristic_primary_png_1.default, alt: `img-${variant}` }),
            react_1.default.createElement("img", { src: card_futuristic_primary_png_1.default, alt: `img-${variant}` }),
            react_1.default.createElement("img", { src: card_futuristic_primary_png_1.default, alt: `img-${variant}` }),
            react_1.default.createElement("img", { src: card_futuristic_primary_png_1.default, alt: `img-${variant}` }))) : // : variant === "futuristic-secondary" ? (
            //   <div className={`bg-futuristic`}>
            //     <img src={CardFuturisticSecondary} alt={`img-${variant}`} />
            //     <img src={CardFuturisticSecondary} alt={`img-${variant}`} />
            //   </div>
            // )
            variant === "futuristic-tartiary" ? (react_1.default.createElement("div", { className: `bg-futuristic` },
                react_1.default.createElement("img", { src: card_futuristic_tartiary_svg_1.default, alt: `img-${variant}` }),
                react_1.default.createElement("img", { src: card_futuristic_tartiary_svg_1.default, alt: `img-${variant}` }))) : variant === "futuristic-quadratic" ? (react_1.default.createElement("div", { className: `bg-futuristic` },
                react_1.default.createElement("img", { src: card_futuristic_quadratic_svg_1.default, alt: `img-${variant}` }),
                react_1.default.createElement("img", { src: card_futuristic_quadratic_svg_1.default, alt: `img-${variant}` }))) : null));
};
exports.FCard = FCard;
//# sourceMappingURL=Fcard.js.map